import {Box, Button, Stack, Typography} from "@mui/material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import coin from "../../../public/coin-svgrepo-com.svg";
import {liquidGlassStyle} from "../../app/theme/liquidGlassStyle.ts";
import {VideoIcon} from "./VideoIcon.tsx";

interface ICustomVideoPreviewProps {
    title: string;
    price: number;
    onChangeClick: () => void;
}

export const CustomVideoPreview = ({title, price, onChangeClick}: ICustomVideoPreviewProps) => {
    return (
        <Stack
            direction="column"
            alignItems="center"
            spacing={1}
            sx={{
                alignSelf: 'flex-end',
                borderRadius: '12px',
                minWidth: '150px',
            }}
        >
            <Stack
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                spacing={0}
                sx={{
                    width: '100%',
                    height: '220px',
                    borderRadius: '14px',
                    position: 'relative',
                    ...liquidGlassStyle,
                }}
            >
                <Typography variant={'h6'} sx={{opacity: 0.9, textAlign: 'center', fontWeight: 600}}>{title}</Typography>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px'}}>
                    <Typography sx={{textAlign: 'center', fontSize: '14px', margin: 0}}>{price}</Typography>
                    <Box component={'img'} src={coin} alt={'coin'} width={'12px'} height={'12px'} sx={{opacity: 0.8, margin: 0}}/>
                </Box>
                <VideoIcon />
            </Stack>
            <Button
                onClick={onChangeClick}
                variant="text"
                size="small"
                startIcon={<SwapHorizIcon />}
                sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '12px',
                    width: '100%',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none',
                    backdropFilter: 'none',
                    WebkitBackdropFilter: 'none',
                }}
            >
                Change Effect
            </Button>
        </Stack>
    );
};
